<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-2">
      <!-- begin col-12 -->
      <div class="col-lg-12">
        <div class="widget-chart" :class="{ 'inverse-mode': inverseMode }">
          <div
            class="widget-chart-content"
            :class="{ 'bg-black': inverseMode }"
          >
            <h4
              class="chart-title ts-flex ts-justify-between"
              :class="{ 'text-gray': !inverseMode }"
            >
              <strong> {{ $t('dashboardcomponents.studentGrade') }} </strong>
              <select
                class="filter"
                :class="{ 'filter-dark': inverseMode }"
                v-model="selectedFilter"
                @change="fetchData"
              >
                <option
                  v-for="(filter, filterKey) in filters"
                  :value="filterKey"
                  :key="filterKey"
                >
                  {{ filter }}
                </option>
              </select>
            </h4>
            <ts-loading-banner :loading="loading">
              <div
                class="widget-chart-full-width ts-px-4"
                :class="{ 'nvd3-inverse-mode': inverseMode }"
              >
                <p>
                  {{
                    $t(
                      'dashboardcomponents.barChartsShowTheStatisticsOfStudentGradingBasedOnTheselectedCategory'
                    )
                  }}
                </p>
                <bar-chart
                  :data="{
                    labels: labels,
                    datasets: datasets
                  }"
                  :options="options"
                  class="height-sm"
                ></bar-chart>
              </div>
            </ts-loading-banner>
          </div>
        </div>
      </div>
      <!-- end col-12 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import { keys, map } from 'lodash'

export default {
  components: {
    BarChart
  },
  props: ['inverseMode'],
  data() {
    return {
      filters: {
        term_name: 'Term',
        acps_abbr: 'Sub Progam',
        acp_abbr: 'Academic Progam',
        ac_year: 'Academic Year'
      },
      loading: false,
      selectedFilter: '',

      // BarChart student grade
      grades: [],
      resources: [],
      borderColor: [
        '#0B5345',
        '#0E6655',
        '#117A65',
        '#1B4F72',
        '#21618C',
        '#2874A6',
        '#641E16',
        '#7B241C',
        '#922B21',
        '#4A235A',
        '#5B2C6F',
        '#6C3483',
        '#6E2C00',
        '#873600',
        '#A04000',
        '#424949',
        '#515A5A',
        '#616A6B'
      ],
      backgroundColor: [
        'rgba(11, 83, 69, 0.7)',
        'rgba(14, 102, 85, 0.7)',
        'rgba(17, 122, 101, 0.7)',
        'rgba(27, 79, 114, 0.7)',
        'rgba(33, 97, 140, 0.7)',
        'rgba(40, 116, 166, 0.7)',
        'rgba(100, 30, 22, 0.7)',
        'rgba(123, 36, 28, 0.7)',
        'rgba(146, 43, 33, 0.7)',
        'rgba(74, 35, 90, 0.7)',
        'rgba(91, 44, 111, 0.7)',
        'rgba(108, 52, 131, 0.7)',
        'rgba(110, 44, 0, 0.7)',
        'rgba(135, 54, 0, 0.7)',
        'rgba(160, 64, 0, 0.7)',
        'rgba(66, 73, 73, 0.7)',
        'rgba(81, 90, 90 , 0.7)',
        'rgba(97, 106, 107, 0.7)'
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed: {
    // bar chart
    labels() {
      return keys(this.resources)
    },
    datasets() {
      return this.grades.map((grade, index) => {
        return {
          label: grade,
          borderColor: this.borderColor[index],
          backgroundColor: this.backgroundColor[index],
          borderWidth: 1,
          data: map(this.resources, r => {
            return r[grade]
          })
        }
      })
    }
  },
  mounted() {
    this.selectedFilter = Object.keys(this.filters)[0]

    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchStudentGrade', {
          group_by: this.selectedFilter
        })
        .then(responses => {
          this.grades = responses.grades
          this.resources = responses.collection
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.text-gray {
  color: #585a5e;
}
.widget-chart .widget-chart-content {
  margin-right: 0;
}
</style>
